import { onExecuteRibbonPinnedMessageExtension } from '../actions/onExecuteRibbonPinnedMessageExtension';
import type { MailEntrypoint } from 'owa-m365-acquisitions/lib/types';
import type { AppButtonOnExecuteParameter } from 'owa-acui';

export function ribbonPinnedMessageExtensionOnExecute(
    appId: string,
    targetWindow: Window,
    entrypoint: MailEntrypoint,
    itemId?: string,
    composeId?: string,
    params?: AppButtonOnExecuteParameter
): void {
    onExecuteRibbonPinnedMessageExtension({
        appId,
        targetWindow,
        entrypoint,
        itemId,
        composeId,
        params,
    });
}
